import { AlertTriangle, Clock, FileQuestion, ShieldCheck, Image, FileText, Mic, Video, HardDrive, File } from "lucide-react";
import { t } from "@/i18n";

const CONF = {
  high: ["chip-ok", "High confidence"],
  medium: ["chip-warn", "Medium confidence"],
  low: ["chip-err", "Low confidence"],
  none: ["chip-err", "No coverage"],
};
export const ConfidencePill = ({ level, testid }) => {
  if (!level) return null;
  const [cls, label] = CONF[level] || CONF.medium;
  return <span className={`chip ${cls}`} data-testid={testid || "confidence-pill"}>{t(label)}</span>;
};

const STATUS = {
  published: ["chip-ok", ShieldCheck, "Published"],
  draft: ["chip-info", FileText, "Draft"],
  processing: ["chip-muted", Clock, "Processing"],
  outdated: ["chip-warn", AlertTriangle, "Outdated"],
  failed: ["chip-err", AlertTriangle, "Failed"],
  archived: ["chip-muted", File, "Archived"],
  rejected: ["chip-err", AlertTriangle, "Not approved"],
};
export const StatusBadge = ({ status }) => {
  const [cls, Icon, label] = STATUS[status] || STATUS.draft;
  return (
    <span className={`chip ${cls}`} data-testid={`status-badge-${status}`}>
      <Icon size={12} /> {t(label)}
    </span>
  );
};

const COVERAGE = {
  answered: ["chip-ok", ShieldCheck, "Fully covered"],
  partial: ["chip-warn", AlertTriangle, "Partially covered"],
  not_found: ["chip-err", FileQuestion, "Not in knowledge base"],
};
export const CoveragePill = ({ coverage }) => {
  const [cls, Icon, label] = COVERAGE[coverage] || COVERAGE.not_found;
  return <span className={`chip ${cls}`} data-testid="coverage-pill"><Icon size={12} /> {t(label)}</span>;
};

const KIND = { photo: Image, video: Video, audio: Mic, text: FileText, drive: HardDrive, document: File };
export const KindIcon = ({ kind, size = 16 }) => {
  const Icon = KIND[kind] || File;
  return <Icon size={size} />;
};
